import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context";
import { ExpandedTableRowLoader } from "pro-features/components/Loaders/src/ExpandedTableRowLoader/ExpandedTableRowLoader";

import { useHighLevelMetricsData } from "../hooks/useHighLevelMetricsData";

import { MetricTabs } from "./components/MetricTabs";
import { useHighLevelMetricsContext } from "./context";
import { useMetricSummaryData } from "./hooks/useMetricSummaryData";

export const HighLevelMetrics = () => {
    const { queryParams } = useHighLevelMetricsContext();
    const { categories } = useCategoriesComparison();
    const { data, isLoading } = useHighLevelMetricsData(queryParams, categories[0]?.category);
    const metricSummaryData = useMetricSummaryData({ average: data?.Average, isLoading });

    return isLoading ? <ExpandedTableRowLoader /> : <MetricTabs enrichmentData={metricSummaryData} />;
};
